import React, { useState } from 'react';
import { Box, Container, Heading, Text, VStack, Icon, SimpleGrid, Flex } from '@chakra-ui/react';
import { Plus } from 'lucide-react';

interface PropsInterface {
	children?: React.ReactNode;
	faqs: { question: string; answer: string }[];
}

const FAQSection = (props: PropsInterface) => {
	const [openIdx, setOpenIdx] = useState<number | null>(null);

	return (
		<Box as="section" borderTop="1px solid" borderColor="gray.100" bg="white" py={28}>
			<Container maxW="1400px" px={8}>
				<SimpleGrid columns={{ base: 1, lg: 2 }} gap={16}>
					<Box>
						<Text
							fontSize="11px"
							fontWeight="600"
							textTransform="uppercase"
							letterSpacing="0.22em"
							color="gray.400"
						>
							FAQ
						</Text>
						<Heading
							mt={4}
							fontSize={{ base: '2rem', md: '3.25rem' }}
							fontWeight="400"
							lineHeight="1.02"
							letterSpacing="-0.035em"
						>
							Questions, <br />
							<Text as="span" color={'gray.500'}>
								answered.
							</Text>
						</Heading>
						<Text mt={5} maxW="sm" fontSize="15px" lineHeight="tight" color="gray.500">
							Everything you need to know about our AI image and video production platform.
						</Text>
					</Box>

					<VStack
						align="stretch"
						gap={0}
						borderY="1px solid"
						borderColor="gray.100"
						divideY="1px"
						divideColor="gray.100"
					>
						{props.faqs.map((faq, index) => (
							<Box
								key={index}
								py={6}
								as="details"
								onToggle={(e: any) => setOpenIdx(e.target.open ? index : null)}
							>
								<Box
									as="summary"
									display="flex"
									cursor="pointer"
									alignItems="start"
									justifyContent="space-between"
									gap={6}
									css={{ '&::-webkit-details-marker': { display: 'none' } }}
								>
									<Text fontSize="18px" fontWeight="500" letterSpacing="tight" color="black">
										{faq.question}
									</Text>
									<Flex
										mt={1}
										h={7}
										w={7}
										flexShrink={0}
										align="center"
										justify="center"
										borderRadius="full"
										border="1px solid"
										borderColor="gray.200"
										color="gray.500"
										transition="all 0.2s"
										transform={openIdx === index ? 'rotate(45deg)' : 'none'}
									>
										<Icon as={Plus} h={3} w={3} strokeWidth={2} />
									</Flex>
								</Box>
								<Text mt={4} maxW="2xl" fontSize="14.5px" lineHeight="relaxed" color="gray.500">
									{faq.answer}
								</Text>
							</Box>
						))}
					</VStack>
				</SimpleGrid>
			</Container>
		</Box>
	);
};

export default FAQSection;
